import { onlySecondsComma } from '../../../normalizers/normalize';

export const LatLngCalc = (coord) => {
    let latLng = parseFloat(coord.minuto) / 60 + parseFloat(coord.grau) + parseFloat(coord.segundo) / 3600;
    return coord.direcao === 'SUL' || coord.direcao === 'OESTE' ? latLng * -1 : latLng;
};

export const LatLngCalcBack = (coord) => {
    let direcao = false;

    if (coord < 0) {
        direcao = true;
        coord *= -1;
    }

    let grau = Math.floor(coord);
    coord = (coord - grau) * 60;

    let minuto = Math.floor(coord);
    coord = (coord - minuto) * 60;

    let segundo = coord;

    return {
        grau: grau,
        minuto: minuto,
        segundo: onlySecondsComma(segundo),
        direcao: direcao
    };
};

export default LatLngCalc;
